import { render, staticRenderFns } from "./SMSManageList.vue?vue&type=template&id=5891122a"
import script from "./SMSManageList.vue?vue&type=script&lang=js"
export * from "./SMSManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports